import { Provider } from 'wikr-core-analytics';
import { ERROR_LEVELS, SENTRY_ANALYTIC } from 'sentry-utils';

import { setPlatform } from 'redux/user/actions';
import { setUrlParams as setUrlParamsToStore } from 'redux/onboadring/actions';

import { URL_PARAMS_MAPPING } from './constants';

import sentry from 'services/Sentry/SentryInstance';

import { isEmpty, getDeviceOS, getUrlSearchEntries, getUrlParams as getUrlParamsUtil } from 'helpers/utils';

const getResolveParams = async (value) => {
    return new Promise((resolve) => {
        resolve(value);
    });
};

export const setAnalyticData = async ({ country, abTestName, email, user_id }) => {
    await Provider.provideData({
        country: async () => await getResolveParams(country),
        abTestName: async () => await getResolveParams(abTestName),
        clientHandlerFn: (error) => sentry.logError(error, SENTRY_ANALYTIC, ERROR_LEVELS.ERROR, {}),
        userEmail: email,
        userId: user_id,
    });
};

export const setUrlParams = (dispatch) => {
    const params = getUrlParamsUtil();

    if (!isEmpty(params)) dispatch(setUrlParamsToStore(params));
};

export const setOnbordingParamsFromUrl = (dispatch) => {
    const urlSearchEntries = getUrlSearchEntries();

    Array.from(urlSearchEntries).forEach(([key, value]) => {
        const mappingItem = URL_PARAMS_MAPPING[key];

        if (!mappingItem) return;

        const { action, modificator } = mappingItem;
        let payload = modificator ? modificator(value) : value;

        dispatch(action(payload));
    });
};

export const setUserPlatform = (dispatch) => {
    const platform = getDeviceOS();

    dispatch(setPlatform(platform));
};
